export enum CallEventsEnum {
  INCOMING = 'INCOMING',
  ACCEPTED = 'ACCEPTED',
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED',
  OUTGOING = 'OUTGOING',
  TRANSFERRED = 'TRANSFERRED'
}
